// App shell: sidebar collapse toggle with localStorage persistence

const STORAGE_KEY = 'pakuj:sidebarCollapsed';

function initSidebar(): void {
    const appShell = document.getElementById('appShell');
    const sidebar  = document.querySelector<HTMLElement>('.sb');
    const btn      = document.getElementById('sbCollapseBtn');
    const lbl      = document.getElementById('sbCollapseLbl');

    if (!appShell || !sidebar || !btn) return;

    const collapsed = localStorage.getItem(STORAGE_KEY) === 'true';
    if (collapsed) applyCollapsed(true, appShell, lbl);

    btn.addEventListener('click', () => {
        const next = !appShell.classList.contains('contracted');
        applyCollapsed(next, appShell, lbl);
        localStorage.setItem(STORAGE_KEY, String(next));
    });

    // Rotate profile chip chevron in sync with Bootstrap collapse events
    const profileSub = document.getElementById('sbProfileSub');
    if (profileSub) {
        profileSub.addEventListener('show.bs.collapse', () => {
            document.querySelectorAll('.sb-user').forEach(el => el.classList.add('expanded'));
        });
        profileSub.addEventListener('hide.bs.collapse', () => {
            document.querySelectorAll('.sb-user').forEach(el => el.classList.remove('expanded'));
        });
    }

    // Rotate admin toggle chevron in sync with Bootstrap collapse events
    const adminSub = document.getElementById('sbAdminSub');
    if (adminSub) {
        const adminToggle = document.querySelector<HTMLElement>('[data-bs-target="#sbAdminSub"]');
        adminSub.addEventListener('show.bs.collapse', () => adminToggle?.classList.add('expanded'));
        adminSub.addEventListener('hide.bs.collapse', () => adminToggle?.classList.remove('expanded'));
    }
}

function applyCollapsed(collapsed: boolean, appShell: HTMLElement, lbl: HTMLElement | null): void {
    appShell.classList.toggle('contracted', collapsed);
    if (lbl) lbl.textContent = collapsed ? 'Expand' : document.documentElement.lang?.startsWith('sr') ? 'Skupi meni' : 'Collapse sidebar';
}

document.addEventListener('DOMContentLoaded', initSidebar);
